import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { EnvType } from '@wix/editor-platform-private-api';
import { ApplicationType } from '@wix/editor-application';
import { createEditorPlatformWorkerError, EditorPlatformWorkerErrorCode } from '../../errors';
import { IFrameHostEndpoint } from '@wix/editor-platform-transport';
import { PlatformConsumerEnvironmentAPIType } from '@wix/editor-application/environment-api';
var _PlatformFrameStrategy_brand = /*#__PURE__*/new WeakSet();
export class PlatformFrameStrategy {
  constructor(ps, limitedPrivateAPI, events) {
    this.ps = ps;
    this.limitedPrivateAPI = limitedPrivateAPI;
    this.events = events;
    /**
     * Cleanup closed iframes.
     * Closed iframes do not have content windows on them
     */
    _classPrivateMethodInitSpec(this, _PlatformFrameStrategy_brand);
    _defineProperty(this, "apis", new Map());
  }
  notify(event) {
    _assertClassBrand(_PlatformFrameStrategy_brand, this, _cleanup).call(this);
    for (const frameAPI of this.apis.values()) {
      frameAPI.notify(event);
    }
  }
  connect(appDefinitionId, iframe) {
    // TODO: store connect map by iframe.contentWindow, should prevent multiple connect calls for the same iframe
    // the problem roots are in editor react ref={e => {}
    const frameInitEvent = this.events.factories.createIframeInitEvent(iframe.src, iframe.id || iframe.src);
    return this.events.withEvent(frameInitEvent, async () => {
      if (!iframe.contentWindow) {
        throw createEditorPlatformWorkerError(EditorPlatformWorkerErrorCode.FrameInitError, 'frame "contentWindow" is not available');
      }
      let applicationPrivateAPI;

      /**
       * to discuss –
       * currently we have cases when we run frame for CE,
       * but there is no running application with the needed appDefinitionId
       * by design we throw exception if call any operation over application
       * which does not exist.
       *
       * this is temporary try/catch
       *
       * as soon as we run CE app, we remove this statement.
       */
      try {
        applicationPrivateAPI = await this.ps.apps.getPrivateAPI(appDefinitionId);
      } catch (e) {
        applicationPrivateAPI = {};
      }
      IFrameHostEndpoint.connect(iframe, async transport => {
        const frameAPI = await transport.waitAPI(PlatformConsumerEnvironmentAPIType.Frame);
        this.apis.set(iframe, frameAPI);
        const limitedPrivateAPI = this.limitedPrivateAPI.build({
          type: ApplicationType.EditorAddon,
          env: EnvType.Frame
        });
        await frameAPI.initEnvironment({
          appDefinitionId,
          privateAPI: limitedPrivateAPI,
          applicationPrivateAPI
        });
      });
    });
  }
}
function _cleanup() {
  for (const iframe of this.apis.keys()) {
    if (!iframe.contentWindow) {
      this.apis.delete(iframe);
    }
  }
}
//# sourceMappingURL=PlatformFrameStrategy.js.map